export function disallowedFileTypeMessage(allowedMimeTypes) {
    const names = allowedMimeTypes.map((mimeType) => mimeType.split('/')[1].toUpperCase());
    const list = names.length > 1 ? `${names.slice(0, -1).join(', ')} or ${names.at(-1)}` : names[0];
    return `File type is not allowed. Use ${list}.`;
}
//# sourceMappingURL=disallowed-file-type-message.js.map